<template>
  <div>
    <span class="titleslight--text font-weight-medium">{{titulo}}</span>
    <IconoInformacion :sInformacion="sInformacion"/>

    <div class=" my-2 pa-2">
     <dinamicos ref="cmpDinamico"
        :aSchema="aSchema"
        :bActivarBotones="false"
        :idFormulario="valorFiltro"
        :aData="aDataDinamicos"
        :key="nKeyDinamicosRefresh"
        :bSubdominioTemporal="bSubdominioTemporal"
        :bDeshabilitado="bDeshabilitado"
      />
      
    </div>
  </div>
</template>

<script>
  import axiosServices from '@/services/axiosServices.js'
  import FormMixin from '@/mixins/formularioMixin.js'
  import mxFunciones from '@/mixins/funciones.js'
  import Dinamicos from '@/components/dinamicos/Dinamicos.vue'
  import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'

  export default {
    name: 'FormDinamicos',
    mixins: [ FormMixin, mxFunciones ],
    components: {
      Dinamicos,
      IconoInformacion,
    },
    props: {
      inner:{
        type: String,
        default: ''
      },
      campoFiltro: {    // nombre del campo en la tabla por el cual se filtra
        type: String,
        default: ''
      },
      valorFiltro: {   // Valor por el cual se filtra
        type: String,
        default: ''
      }
    },
    data() {
      return {
        aSchema: [],
        nKeyDinamicosRefresh: 0,
        aDataDinamicos:[],
        bDeshabilitado: false,
        aErrores: []
      }
    },
    methods: {
      async onCargarFormulario(){
        this.bLoading = true
        const axiosLoadFormulario = await axiosServices.getConfiguration(`/gestiondocumental/loadformulario/${this.valorFiltro}`, true, this.sParamsSubdominiot )
        this.aSchema = await axiosLoadFormulario.aData  // estructura del dinamico
        this.nKeyDinamicosRefresh++
        this.bLoading = false
      },
      onValidarFormulario(){
        if(!this.$refs.cmpDinamico.validarObligatorios()){
          this.$refs.cmpDinamico.mostrarErrores = false   // le indico al componente que no muestre su mensaje de error
          this.aErrores = this.$refs.cmpDinamico.aErrores
        }else{
          this.aErrores = []
        }
      }
    },
    computed: {
      nLongitudData () {
        return this.aDataDinamicos.length
      }
    },
    watch: {
      valorFiltro(sNuevovalor){
        if(sNuevovalor!== '') this.onCargarFormulario()
      },
      nLongitudData() {
        this.$emit('input', this.aDataDinamicos)
      },
      aDataDinamicos() {
        this.$emit('input', this.aDataDinamicos)
      }
    },
    mounted() {
      this.onCargarFormulario()
    }
  }
</script>

<style lang="scss" >
  .cont-upfiles {
    border: 2px solid var(--v-blue_light-base);
    background: #F5FFFF;
    border-radius: 10px;
  }
  .dropbox {
    // outline: 2px dashed grey; /* the dash box */
    border: 1px solid var(--v-blue_light-base);
    border-radius: 10px;
    color: dimgray;
    min-height: 60px; /* minimum height */
    position: relative;
    cursor: pointer;
    transition: all ease-in-out 0.3s;
    background: var(--v-blue_light-base);
    width: 100%;
    .icon-upload{
      margin: 0 auto;
      text-align: center;
    }
    p {
      text-align: center;
      margin: 0;
      padding: 0;
      font-size: 0.9em;
      line-height: 1.2em;
      transition: all ease-in-out 0.3s;
      // color:var(--v-blue_light-base);
    }
  }
  .dropbox:hover {
    background: var(--v-primary-base); /* when mouse over to the drop zone, change color */
    .icon-upload{
      i{
      color: var(--v-blue_light-base);
      }
    }
    p{
      color:var(--v-blue_light-base);
    }
  }
  
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100px;
    top: 0px;
    left: 0px;
    position: absolute;
    cursor: pointer;
  }
  
  
  .list-unstyled {
    font-size: 0.8em;
    line-height: 1.1em;
    color: #424242;
    list-style: none;
    margin: 0!important;
    padding: 0!important;
    p{
      margin: 0px;
      padding: 0px;
    }
  }

.cont-listfiles{
  // border: solid blue;
  width: 100%;
}

</style>
